 $(function(){
    $(".fot_img").click(function(){
      if($(this).hasClass("off")){
        $(this).removeClass("off");
        $(this).parent().siblings(".footer__item-content").slideUp();
        $(this).css("background","url(https://cdn.shopify.com/s/files/1/0608/4830/8382/files/jiahao_white.png?v=1679302062) no-repeat").css("background-size","1rem 1rem");
      }else{
        $(".fot_img").removeClass("off");
        $(".fot_img").parent().siblings(".footer__item-content").slideUp();
        $(".fot_img").css("background","url(https://cdn.shopify.com/s/files/1/0608/4830/8382/files/jiahao_white.png?v=1679302062) no-repeat").css("background-size","1rem 1rem");
        $(this).addClass("off");
        $(this).parent().siblings(".footer__item-content").slideDown();
        $(this).css("background","url(https://cdn.shopify.com/s/files/1/0608/4830/8382/files/jianhao_white.png?v=1679302062) no-repeat").css("background-size","1rem 1rem");
        
      }

    })
  })

$(function () {
var mySwiper = new Swiper('#mobile-show-ads', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  }

  // // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // }
})
})
$(function () {
  var flashSwipers = new Swiper('.today-special_swiper' , {
      direction: 'horizontal',
      autoplay: {
		delay: 5000,
		disableOnInteraction: false,
      },
      spaceBetween: 30,
      slidesPerView: 5,
      navigation: {
        nextEl: '.today-special_swiper .swiper-button-prev',
        prevEl: '.today-special_swiper .swiper-button-next',
      }
  });
    var mobflashSwipers = new Swiper('.m-home-flashsale' , {
      direction: 'horizontal',
      autoplay: {
		delay: 5000,
		disableOnInteraction: false,
      },
      spaceBetween: 10,
      slidesPerView: 2.3,
      navigation: {
        nextEl: '.m-home-flashsale .swiper-button-prev',
        prevEl: '.m-home-flashsale .swiper-button-next',
      }
  });
})
window.timeZoneParams = -7;
window.getLocalTime = function (i) {
    if (typeof i !== 'number') return;
    var d = new Date();
    var len = d.getTime();
    var offset = d.getTimezoneOffset() * 60000;
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
}
window.getNextDate = function(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "/" + m + "/" + d;
};
window.endTimeFn = function() {
    var date = getLocalTime(timeZoneParams);
    var dateYear = date.getFullYear();
    var dateMonth = date.getMonth() + 1;
    var dateDate = date.getDate();
    var date2 = getNextDate(dateYear+'/'+dateMonth+'/'+ dateDate,1);
    var blackLimitTime = new Date(date2).getTime() - date;
    return blackLimitTime;
}
//Flash Sale Home Page
$(function () {
    var flasDate = getLocalTime(timeZoneParams);
    var flashWeek = flasDate.getDay();
    if(flashWeek==0){
        flashWeek=7;
    }
    var flash_start_time = '2022/9/20 00:00:00';
    var flash_end_time = '2030/9/20 00:00:00' ;
    if(typeof flash_start_time != 'undefined'){
                      var date = getLocalTime(timeZoneParams);
                      var startFlashTime =new Date(flash_start_time);
                      var endFlashTime =new Date(flash_end_time);
                      var endAllFlashTime = endFlashTime.getTime() -date;
                      var allFlashTime = startFlashTime.getTime() - date;
                      function timerFlash(intDiff){
                          var day=0,
                              hour=0,
                              minute=0,
                              second=0;
                          intDiff = intDiff - 0;
                          if(intDiff > 0){
                              hour = Math.floor(intDiff /1000/60/60);
                              minute = Math.floor(intDiff /1000/60%60);
                              second =  Math.floor(intDiff/1000%60);
                          }
                          if(hour<10){
                              $('.home-flashClock_time--H .home-flashClock_time--num').text('0' + hour);
                          }else {
                              $('.home-flashClock_time--H .home-flashClock_time--num').text( hour);
                          }
                          if(minute<10){
                              $('.home-flashClock_time--M .home-flashClock_time--num').text('0' + minute);
                          }else {
                              $('.home-flashClock_time--M .home-flashClock_time--num').text(minute);
                          }
                          if(second<10){
                              $('.home-flashClock_time--S .home-flashClock_time--num').text('0' + second);
                          }else {
                              $('.home-flashClock_time--S .home-flashClock_time--num').text(second);
                          }
                      }
                      var startFlashFlag = true;
                      var endFlashFlag = true;
                      var endAllFlashTimeToday;
                      var limitFlashTime = setInterval(function(){
                          if(allFlashTime > 0){
                         
                              if(startFlashFlag){
                                  $('.home-flash_clock').hide();
                                  startFlashFlag = false;
                              }
                              allFlashTime = allFlashTime -1000;
                              // timerFlash(allFlashTime);
                          }else{
                              if(endFlashFlag){
                                  endAllFlashTime = endFlashTime.getTime() - date;
                                  endAllFlashTimeToday = endTimeFn();
                                  endFlashFlag = false;
                              }
                              if(endAllFlashTime > 0){
                                  $('.home-flash_clock').show();
                                  endAllFlashTime = endAllFlashTime - 1000;
                                  endAllFlashTimeToday = endAllFlashTimeToday - 1000;
                                  timerFlash(endAllFlashTimeToday);
                                  if(endAllFlashTimeToday < 0){
                                      endAllFlashTimeToday = endTimeFn();
                                  }
                              }else {
                                  clearInterval(limitFlashTime);
                              }
                          }
                      },1000);
            }
})

$(function () {
    $(".purchase-info-title.add_div").click(function(){
      if($(this).hasClass("off")){
          $(this).removeClass("off");
          $(this).next().slideDown();
          $(this).css("background","#828282 url(https://cdn.shopify.com/s/files/1/0654/7603/4783/files/jianhao_white.png?v=1679363661) no-repeat right 6px center").css("background-size","1rem 1rem");
        }else{
          $(this).addClass("off");
          $(this).next().slideUp();
          $(this).css("background","#828282 url(https://cdn.shopify.com/s/files/1/0654/7603/4783/files/jiahao_white.png?v=1679363661) no-repeat right 6px center").css("background-size","1rem 1rem");
        }
     })
      $(".add_div.detail-pro-title").click(function(){
      if($(this).hasClass("off")){
          $(this).removeClass("off");
          $(this).next().slideDown();
          $(this).css("background","#828282 url(https://cdn.shopify.com/s/files/1/0654/7603/4783/files/jianhao_white.png?v=1679363661) no-repeat right 6px center").css("background-size","1rem 1rem");
          $(".default_hidden_reviews").css("display","flex");
        }else{
          $(this).addClass("off");
          $(this).next().slideUp();
         $(".default_hidden_reviews").css("display","none");
          $(this).css("background","#828282 url(https://cdn.shopify.com/s/files/1/0654/7603/4783/files/jiahao_white.png?v=1679363661) no-repeat right 6px center").css("background-size","1rem 1rem");
        }
     })
      $(".pro-tabs .ifots_img").click(function(){
      if($(this).hasClass("off")){
        $(this).removeClass("off");
        $(this).parent().siblings(".pro-tabs .product-single__accordion__item").slideUp();
      }else{
        $(".pro-tabs .ifots_img").removeClass("off");
        $(".pro-tabs .ifots_img").parent().siblings(".pro-tabs .product-single__accordion__item").slideUp();
        $(this).addClass("off");
        $(this).parent().siblings(".pro-tabs .product-single__accordion__item").slideDown();
        
      }

    })
    $(".judgeme-review-tab .ifots_img").click(function(){
      if($(this).hasClass("off")){
        $(this).removeClass("off");
        $(this).parent().siblings(".judgeme-review-tab .product-single__accordion__item").slideUp();
      }else{
        $(".judgeme-review-tab .ifots_img").removeClass("off");
        $(".judgeme-review-tab .ifots_img").parent().siblings(".judgeme-review-tab .product-single__accordion__item").slideUp();
        $(this).addClass("off");
        $(this).parent().siblings(".judgeme-review-tab .product-single__accordion__item").slideDown();
        
      }

    })
})
// $(document).ready(function(){
//      $("#show_reviews_button").append('<div class="default_hidden_reviews"><span>View More</span> <img src="https://cdn.shopify.com/s/files/1/0654/7603/4783/files/down-jiantou-hv.png?v=1682036356" alt="View More - Reviews" ></div>');
//      $("#mobile_product-detail").addClass("telescopic");

//     $("#show_reviews_button .default_hidden_reviews").click(function(){
//     	 var _this= this;
//       	$(this).hide();
//       	$("#mobile_product-detail").removeClass("telescopic");
//       if($('#show_reviews_button').find('.default_show_reviews').length == 0){
//       	$("#show_reviews_button").append(' <div class="default_show_reviews on"><span>Less</span> <img src="https://cdn.shopify.com/s/files/1/0654/7603/4783/files/down-jiantou-hv.png?v=1682036356" alt="Less - Reviews" /></div>');
//       }else{
//       	$("#show_reviews_button").find('.default_show_reviews').show();
//       }
//       $("#show_reviews_button .default_show_reviews").click(function(){
//                 $(this).hide();
//                 $("#mobile_product-detail").addClass("telescopic");
//                  $("#show_reviews_button").find('.default_hidden_reviews').show();
//             });
//     })
     
//   })
    function copyToClipboard(e) {
	var i = document.createElement("textarea");
	i.value = e, i.setAttribute("readonly", ""), i.style.position = "absolute", i.style.left = "-9999px", document.body.appendChild(i);
	var t = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : !1;
	i.select(), document.execCommand("copy"), document.body.removeChild(i), t && (document.getSelection().removeAllRanges(), document.getSelection().addRange(t))
}

function copyCode(e) {
	var i = e.target;
	copyToClipboard(i.getAttribute("data-code")), i.innerText = "copied!", setTimeout(function() {
		i.innerText = "copy"
	}, 1500)
}